import { AccountInfoField, accountInfoErrors } from "./accountInfo";

import { SignupStepProps } from "../signupForm";
import { useState } from "react";

/** What each account info section receives from the step. */
export type SectionProps = Pick<
  SignupStepProps,
  "form" | "updateForm" | "serverErrors"
>;

/** Props wiring a field to the form, with its error shown once the user leaves
 * it rather than while they first type. A server error shows right away. */
export const useAccountInfoFields = ({
  form,
  updateForm,
  serverErrors = {},
}: SectionProps) => {
  const [touched, setTouched] = useState<Set<AccountInfoField>>(new Set());

  const clientErrors = accountInfoErrors(form);
  const errors = { ...clientErrors, ...serverErrors };
  const fieldProps = (field: AccountInfoField) => ({
    id: `signup-${field}`,
    onBlur: () => setTouched((prev) => new Set(prev).add(field)),
    error:
      serverErrors[field] ??
      (touched.has(field) ? (clientErrors[field] ?? null) : null),
  });
  const textField = (field: Exclude<AccountInfoField, "facilityTypeId">) => ({
    ...fieldProps(field),
    value: form[field],
    onChange: (value: string) => updateForm({ [field]: value }),
  });
  return { errors, fieldProps, textField };
};
